if (!customElements.get('size-guide-drawer')) {
  customElements.define(
    'size-guide-drawer',
    class SizeGuideDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('.size-guide-close').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      connectedCallback() {
        // Move to <body> so the sticky product column doesn't trap it in its stacking context
        if (this.parentElement === document.body) return;
        document.querySelectorAll('body > size-guide-drawer').forEach((drawer) => drawer.remove());
        document.body.appendChild(this);
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (target != this && !target.closest('size-guide-drawer') && !target.closest('.reaal-size-guide')) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );

  // Delegated so it keeps working if the variant picker is re-rendered
  document.addEventListener('click', (evt) => {
    const button = evt.target.closest('.reaal-size-guide');
    if (!button) return;
    const drawer = document.querySelector('size-guide-drawer');
    if (!drawer) return;
    drawer.hasAttribute('open') ? drawer.hide() : drawer.show(button);
  });
}
